/* js小工具 对标 vue2过滤器 */
import { Message } from 'element-ui';

// 浮点数精确保留n位, 整数不会出现浮点
function toPointFixed (value, fixValue = 2) {
  const target = parseFloat(value).toFixed(fixValue)
  if (target.indexOf('.') === -1) return value
  const values = target.split('.')
  let num = parseInt(values[1]) // 看看小数的整型
  if (num > 10 || num === 0) { // 将小数如9.10、9.00中的0去掉
    num = values[1].replace('0', '').replace('0', '') // 9.00时，num的长度为0
  } else {
    num = values[1] // 保留 9.01的01情况
  }
  if (num.length > 0) {
    return values[0] + '.' + num
  } else {
    return values[0]
  }
}

// 日期格式化
function formatDate (date, type) {
  if (date !== '0') {
    if (date === '' || date === undefined || date === null) {
      return ''
    }
  }
  let dateTime = '--'
  let getDate = date
  if (typeof date !== 'object') {
    if (typeof date === 'string' && date.indexOf('+') >= 0) {
      date = date.split('+')[0]
    }
    getDate = new Date(date)
  }
  const year = getDate.getFullYear()
  const month = addZero(getDate.getMonth() + 1)
  const day = addZero(getDate.getDate())
  const hours = addZero(getDate.getHours())
  const minutes = addZero(getDate.getMinutes())
  switch (type) {
    case 'yyyy-MM-dd':
      dateTime = year + '-' + month + '-' + day
      break;
    case 'MM-dd':
      dateTime = month + '-' + day
      break;
    case 'M月d日 hhmm':
      dateTime = month + '月' + day + '日 ' + hours + ':' + minutes
      break;
    case 'hhmm':
      dateTime = hours + ':' + minutes
      break;
    case 'yyyy/mm/dd':
      dateTime = year + '/' + month + '/' + day;
      break;
    default:
      dateTime = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes
      break;
  }
  return dateTime
}

function addZero (val) {
  if (val < 10) {
    return '0' + val
  } else {
    return val
  }
}

function examTypeName (type, num = 4) {
  const typeNames = [
    '',
    '学前测试', // 蓝色
    '周练', // 蓝色
    '单元练习', // 蓝色
    '月练', // 蓝色
    '期中考试', // 绿色
    '期末考试', // 绿色
    '模拟考试',  // 橙色
    '其它' // 蓝色
  ]
  return typeNames[type] ? typeNames[type].substring(0, num) : type + ''
}

function gradingName (type) {
  const typeNames = {
    NO_SETTING: '',
    NOT_GRADING: '批阅未开始',
    GRADING: '批阅中…',
    PAUSE_GRADING: '暂停中…',
    GRADING_DONE: '结束批阅'
  }
  return typeNames[type] ? typeNames[type] : type + ''
}

function getGradeName (index) {
  const list = ['', '一年级', '二年级', '三年级', '四年级', '五年级', '六年级', '初一', '初二', '初三', '高一', '高二', '高三']
  return list[parseInt(index)]
}

function quesNumLabel (ques) {
  if (ques.bigNum && ques.smallNum) {
    return ques.bigNum + '.' + ques.smallNum
  } else {
    return `第${ques.question || ques.num}题`
  }
}

function typeName (key, index) {
  const obj = {
    evaluateType: ['', '单评', '双评', '三评'],
    assignVersion: {
      VERSION_2: '原版2.0使用',
      TEACHER: '按老师分配',
      SCHOOL: '按学校分配',
      CLASS: '按班级分配'
    },
    assignType: {
      EQUAL_ALLOCATION: '平均分配',
      EFFICIENCY_ALLOCATION: '效率分配',
      EFFICIENCY_PRIORITIZATION: '主动效率优先',
      QUOTA_ALLOCATION: '定额分配',
    },
    reviewStatus: {
      NOT_GRADING: '未批阅',
      GRADING: '批阅中',
      PAUSE_GRADING: '暂停批阅',
      GRADING_DONE: '批阅完成',
    },
    dispenseMethod: {
      TEACHER: '按老师分配',
      SCHOOL: '按学校分配'
    }
  }
  return obj[key][index]
}

// 获取坐标
function getRect (ossUrl) {
  if (ossUrl && ossUrl.includes('crop,')) {
    const rectRanges = ossUrl.split('/crop,')[1].split(',');
    const keys = ['x', 'y', 'w', 'h']
    const rect = {}
    for (let index = 0; index < keys.length; index++) {
      const key = keys[index];
      rect[key] = parseInt(rectRanges[index].replace(key + '_', ''))
    }
    return rect
  }
  return []
}

function markTypeDict () {
  return {
    FIRST: '正常卷批阅',
    SECOND: '仲裁卷评阅',
    THIRD: '三评',
    LEADER: '异常卷批阅'
  }
}

// 检测是否空值
function isEmpty (val) {
  if (typeof val === 'undefined' || val === null || val === '') {
    return true
  }
  return false
}

// 选项坐标解析
function optionCoordinateAnalysis (object) {
  try {
    if (!object) {
      return null
    }
    const optionList = []
    const optionObj = JSON.parse(object)
    for (const item of optionObj) {
      optionList.push({
        option: item.value,
        ...coordinateAnalysis(item.coordinate, true)
      })
    }
    return optionList
  } catch (error) {
    return null
  }
}

// 坐标解析
function coordinateAnalysis (coordinate, isShift = false) {
  if (!coordinate) {
    return {}
  }
  let list = coordinate.split(",");
  if (isShift) {
    list.shift();
  }

  const coordinateItem = {}
  for (const item of list) {
    const obj = item.split('_')
    coordinateItem[obj[0]] = obj[1]
  }
  return coordinateItem;
}

// 坐标集合解析
function coordinateListAnalysis (coordinateList, isShift = false) {
  if (!coordinateList) {
    return []
  }

  const list = [];
  coordinateList.split(";").forEach(item => {
    list.push(coordinateAnalysis(item, isShift))
  })

  return list
}

// 克隆
function deepClone (data) {
  return JSON.parse(JSON.stringify(data));
}

// 差异
function diff (target, source) {
  return target.filter(i => {
    return source.findIndex(s => s.id === i.id) < 0;
  });
}

// 标识
function guid () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = Math.random() * 16 | 0,
      v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

// 是否是重叠词AAB、BB
function isReduplication (answer) {
  let repeat = false;
  for (let i = 0; i < answer.length; i++) {
    let remain = answer.substr(i + 1);
    if (remain.indexOf(answer.charAt(i)) > -1) {
      repeat = true;
      break;
    }
  }
  return repeat;
}

// 答案排序
function sortAnswer (answer) {
  return answer.split('').sort((a, b) => {
    if (a > b) {
      return 1;
    } else {
      return -1;
    }
  }).join('');
}

// 是否是相同题目
function sameTopic (target, source) {
  return target.bigNum + target.smallNum + '' === source.bigNum + source.smallNum + ''; // 大题号 + 小题号一样就是相同题目
}

// 生成试题题号
function standardQuestionNumber (question) {
  return question.bigNum && question.smallNum ? question.bigNum + "." + question.smallNum : question.question ? question.question : question.num ? question.num : '--'
}

// 生成选项数据
function generateOptionData (num) {
  const length = optionList.length > num ? num : optionList.length
  let optionText = ''
  for (let i = 0; i < length; i++) {
    optionText += optionList[i] + '\n'
  }
  return optionText.trimEnd('\n')
}
// 获取选择数据
function getOptionData (num) {
  const length = optionList.length > num ? num : optionList.length
  return optionList[length].trim('')
}

async function copyTip (event) {
  // 保留原始格式
  const lines = event.currentTarget.innerText.split('\n').filter(line => line.trim() !== '')
  lines.push('用户名：' + this.userInfo.nickName)
  lines.push('复制时间：' + new Date().toLocaleString())
  // 获取提示内容
  const content = lines.join('\n')
  // 优先使用 execCommand 方式复制,兼容iframe场景
  try {
    const textarea = document.createElement('textarea')
    textarea.value = content
    document.body.appendChild(textarea)
    textarea.select()
    const result = document.execCommand('copy')
    document.body.removeChild(textarea)
    if (result) {
      Message.success('复制成功')
      return
    }
  } catch (err) {
    console.warn('execCommand copy failed', err)
  }

  // 降级使用 Clipboard API
  try {
    await navigator.clipboard.writeText(content)
    Message.success('复制成功')
  } catch (err) {
    Message.warning('浏览器权限受限，请手动选中内容后按 Ctrl+C (Mac 用户请按 Command+C) 复制')
  }
}

// 将输入值转换为大写并替换全角字符为半角字符
// @param {String} val - 输入的值
// @returns {String} - 处理后的值
function transformInput (val) {
  return val.toUpperCase().replace(/[\uff01-\uff5e]/g, char => String.fromCharCode(char.charCodeAt(0) - 65248));
}

// 函数：将字符串转换为布尔值
function stringToBoolean (str) {
  // 如果字符串不为空且转换为小写后等于"false"，则返回false
  if (!isEmpty(str) && str.toLowerCase() === "false") {
    return false;
  }
  // 否则返回true
  return true;
}

// 根据枚举Key获取指定枚举code
function getEnumCodeByKey (exam, key) {
  const object = exam[key]
  if (object) {
    return object.code
  }
  return -1
}

var optionList = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
function deepCopy (obj, hash = new WeakMap()) {
  // 处理非对象类型
  if (typeof obj !== 'object' || obj === null) {
    return obj
  }

  // 如果obj是日期或正则对象直接返回一个新对象
  if (obj instanceof Date) {
    return new Date(obj)
  }

  if (obj instanceof RegExp) {
    return new RegExp(obj)
  }

  // 如果循环引用则直接返回引用
  if (hash.has(obj)) {
    return hash.get(obj)
  }

  // 处理数组
  if (Array.isArray(obj)) {
    let newArray = []
    hash.set(obj, newArray)
    for (let i = 0; i < obj.length; i++) {
      newArray[i] = deepCopy(obj[i], hash)
    }
    return newArray
  }
  // 处理对象
  let newObj = {}
  hash.set(obj, newObj)
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      newObj[key] = deepCopy(obj[key], hash)
    }
  }

  return newObj
}

function subjectExamName (exam) {
  if (exam.isTwo) {
    return `${exam.subjectName} (二卷)`
  } else {
    return `${exam.subjectName}${exam.hasTwo ? ' (主卷)' : ''}`
  }
}

export default {
  toPointFixed,
  formatDate,
  examTypeName,
  getGradeName,
  gradingName,
  quesNumLabel,
  typeName,
  getRect,
  markTypeDict,
  isEmpty,
  optionCoordinateAnalysis,
  coordinateListAnalysis,
  coordinateAnalysis,
  deepClone,
  isReduplication,
  diff,
  guid,
  sortAnswer,
  sameTopic,
  standardQuestionNumber,
  generateOptionData,
  getOptionData,
  transformInput,
  copyTip,
  stringToBoolean,
  getEnumCodeByKey,
  deepCopy,
  subjectExamName
};


// WEBPACK FOOTER //
// ./src/v2/utils/util.js